document.addEventListener('DOMContentLoaded', function() {
    const customerAccessTokenKey = window.customerAccessTokenKey;

    // Shopify にログイン済みで、デザインの保存などに使うアクセストークンもあるときは、ログインし直す必要がないので
    // 戻り先（無ければマイページ）へ進む。
    // アクセストークンが無いとき（別の端末・ブラウザのデータの削除・有効期限切れなど）は、デザインの保存や会員情報の変更ができず、
    // シミュレーターなどからここへ案内されてくるので、フォームを出してログインし直してもらい、アクセストークンを取り直す
    if (window.isLogin) {
      if (hasStoredCustomerAccessToken()) {
        window.location.href = getSafeReturnToFromUrl() || '/account';
        return;
      }
      showReLoginNotice();
    }

    // 有効期限（expiresAt）を過ぎたトークンは、バックエンドで会員として扱われないので、無いものとして扱う
    function hasStoredCustomerAccessToken() {
      try {
        const customerAccessToken = JSON.parse(localStorage.getItem(customerAccessTokenKey));
        if (!customerAccessToken || !customerAccessToken.accessToken) return false;
        const expiresAt = Date.parse(customerAccessToken.expiresAt);
        return !(Number.isFinite(expiresAt) && expiresAt <= Date.now());
      } catch (_) {
        return false;
      }
    }

    // ログインし直してもらう理由を、ログインフォームの上に出す
    function showReLoginNotice() {
      const loginFormBox = document.querySelector('.login-form-box');
      if (!loginFormBox) return;

      const notice = document.createElement('div');
      notice.className = 'login-info-box';
      notice.setAttribute('role', 'status');
      notice.textContent = getSafeReturnToFromUrl()
        ? 'ログインの確認が必要です。お手数ですが、メールアドレスとパスワードを入力して、もう一度ログインしてください。ログインすると、元の画面に戻ります。'
        : 'ログインの確認が必要です。お手数ですが、メールアドレスとパスワードを入力して、もう一度ログインしてください。';
      loginFormBox.parentNode.insertBefore(notice, loginFormBox);
    }

    const loginSection = document.getElementById('login-section');
    const forgotPasswordSection = document.getElementById('forgot-password-section');
    const forgotPasswordCompletedSection = document.getElementById('forgot-password-completed-section');

    const emailLoginInput = document.getElementById('customer-login-email');
    const passwordLoginInput = document.getElementById('customer-login-password');
    const forgotPasswordLink = document.getElementById('forgot-password-link');
    const secretKeyString = window.secretKeyString;

    const GET_CUSTOMER_ACCESS_TOKEN_API_ENDPOINT = window.apiUrl + '/api/get-customer-access-token';
  
    function showForgotPasswordSection() {
      loginSection.classList.add('d-none');
      forgotPasswordSection.classList.remove('d-none');
      forgotPasswordCompletedSection.classList.add('d-none');
      window.location.hash = 'recover';
    }

    function showForgotPasswordCompletedSection() {
      loginSection.classList.add('d-none');
      forgotPasswordSection.classList.add('d-none');
      forgotPasswordCompletedSection.classList.remove('d-none');
      window.location.hash = 'recover-completed';
    }
  
    function showLoginSection() {
      loginSection.classList.remove('d-none');
      forgotPasswordSection.classList.add('d-none');
      forgotPasswordCompletedSection.classList.add('d-none');
      window.location.hash = '';

      const rememberEmail = localStorage.getItem('rememberEmail');
      if (rememberEmail) {
        emailLoginInput.value = rememberEmail;

        const rememberMe = document.getElementById('rememberMe');
        rememberMe.checked = true;
      }
    }
  
    function checkUrlHash() {
      if (window.location.hash === '#recover') {
        showForgotPasswordSection();
      } else if (window.location.hash === '#recover-completed') {
        showForgotPasswordCompletedSection();
      } else {
        showLoginSection();
      }
    }
  
    forgotPasswordLink.addEventListener('click', function(e) {
      e.preventDefault();
      showForgotPasswordSection();
    });
  
    window.addEventListener('hashchange', checkUrlHash);
  
    checkUrlHash();
  
    // Toggle Password Visibility
    const togglePasswordIcon = document.getElementById('togglePasswordIcon');
    togglePasswordIcon.addEventListener('click', function() {
      const iconEye = document.getElementById('icon-eye');
      const iconEyeSlash = document.getElementById('icon-eye-slash');
  
      if (passwordLoginInput.type === 'password') {
        passwordLoginInput.type = 'text';
        iconEye.classList.remove('d-none');
        iconEyeSlash.classList.add('d-none');
      } else {
        passwordLoginInput.type = 'password';
        iconEye.classList.add('d-none');
        iconEyeSlash.classList.remove('d-none');
      }
    });
  
    // Handle Login Form submission
    const loginForm = document.getElementById('customer_login');
    const loginBtn = document.getElementById('login-btn');

    async function submitFormToAPI(userInfoHash) {
      try {
        const response = await fetch(GET_CUSTOMER_ACCESS_TOKEN_API_ENDPOINT, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
          userInfoHash: userInfoHash
        })
        });
  
        return response.json();
      } catch (error) {
        return {
          success: false,
          error: `Network error: ${error.message}`
        };
      }
    }
  
    // ログイン画面の URL の return_to（無ければ return_url）を、ログイン後の戻り先としてフォームの return_to（Shopify 公式）に入れる。
    // 外部サイトへのリダイレクトを防ぐため、同じサイト内の URL だけを受け付ける（script.return-to.js）。
    function appendReturnTo(form) {
      const returnTo = getSafeReturnToFromUrl();
      if (!returnTo) return;

      let input = form.querySelector('input[name="return_to"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        form.appendChild(input);
      }
      input.value = returnTo;
    }

    // 「新規会員登録」に進んでも戻り先を失わないよう、登録リンクに return_to を付け、タブ内にも覚えておく
    const loginPageReturnTo = getSafeReturnToFromUrl();
    const registerLink = document.querySelector('.register-btn');
    if (loginPageReturnTo) {
      savePostAuthReturnTo(loginPageReturnTo);

      if (registerLink) {
        const registerUrl = new URL(registerLink.href, window.location.origin);
        registerUrl.searchParams.set('return_to', loginPageReturnTo);
        registerLink.href = registerUrl.href;
      }
    }

    async function handleLogin() {
      // 入力欄で Enter を続けて押したときに、ログインの送信（と login イベント）が重ならないようにする
      if (loginBtn.disabled) return;
      loginBtn.disabled = true;
      loginBtn.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>ログイン中...';

      const email = emailLoginInput.value;
      const password = passwordLoginInput.value;
      const formError = document.getElementById('form-error');
      formError.classList.remove('show');
  
      const userInfo = JSON.stringify({ email: email, password: password });
      const encryptedUserInfo = await encryptData(secretKeyString, userInfo);

      const result = await submitFormToAPI(encryptedUserInfo);
      if (result.success) {
        const customerAccessToken = result.data;
        if (!customerAccessToken) {
          formError.classList.add('show');
          loginBtn.disabled = false;
          loginBtn.innerHTML = loginBtn.dataset.originalText || 'ログイン';
          return;
        }

        const rememberMe = document.getElementById('rememberMe').checked;
        if (rememberMe) {
          localStorage.setItem('rememberEmail', email);
        } else {
          localStorage.removeItem('rememberEmail');
        }

        if (localStorage.getItem(customerAccessTokenKey)) {
          localStorage.removeItem(customerAccessTokenKey);
        }
      
        localStorage.setItem(customerAccessTokenKey, JSON.stringify(customerAccessToken));
        
        // Fetch favourite product IDs once after login and cache to localStorage
        try {
          // クエリの accessToken は今のバックエンドが読んでいるので残す（後方互換）。
          // Cloud Run のリクエストログに残るので、バックエンドが Authorization ヘッダーを読むようになったらクエリからは外す。
          const favResp = await fetch(
            `${window.apiUrl}/api/favourites?accessToken=${encodeURIComponent(customerAccessToken.accessToken)}`,
            { headers: { Authorization: `Bearer ${customerAccessToken.accessToken}` } }
          );
          const favData = await favResp.json();
          if (favData && favData.success && Array.isArray(favData.products)) {
            const ids = Array.from(new Set(favData.products.map(item => {
              const gid = item.node.id;
              return gid.replace('gid://shopify/Product/', '');
            })));
            localStorage.setItem('favourites_ids', JSON.stringify(ids));
            if (typeof attachFavoriteListeners === 'function') {
              try { attachFavoriteListeners(); } catch (e) {}
            }
          }
        } catch (_) {
          // ignore caching errors; proceed with login
        }
        
        await migrateAnonymousDesigns(customerAccessToken.accessToken);
        appendReturnTo(loginForm);
        // ログインの戻り先はフォームの return_to で渡すので、会員登録用に覚えた戻り先は残さない
        clearPostAuthReturnTo();

        // 直後にフォーム送信で遷移するため、キューに溜めずにすぐ送る（メールアドレス等は送らない）
        window.posthog?.capture?.('login', {
          has_return_to: Boolean(loginForm.querySelector('input[name="return_to"]')?.value)
        }, { send_instantly: true });

        loginForm.submit();
      } else {
        formError.classList.add('show');
        loginBtn.disabled = false;
        loginBtn.innerHTML = loginBtn.dataset.originalText || 'ログイン';
      }
    };

    loginBtn.addEventListener('click', handleLogin);
    emailLoginInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        handleLogin();
      }
    });
    passwordLoginInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        handleLogin();
      }
    });
  });